export default __webpack_public_path__ + "login_background_v2.jpg";